import logger from '../../utils/logger';
import { lendingApiFetchWithoutContentType } from '../lendingApi/lendingApiQueries';

type TSessionHistoryItem = {
  question: string;
  answer: string;
};

export type TCompanyQuestionSessionHistoryResponse = {
  history: TSessionHistoryItem[];
  session_exists: boolean;
  completed: boolean;
};

export const fetchGetCompanyQuestionSessionHistory = async (
  applicationId: string,
): Promise<TCompanyQuestionSessionHistoryResponse> => {
  const response = await lendingApiFetchWithoutContentType(
    `/api/company_question_analysis/session/${applicationId}/history/`,
  );

  if (!response.ok) {
    logger.error('Failed to fetch session history', {
      applicationId,
      status: response.status,
    });
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};
